import React, { useState } from 'react'
import arrow from './images/arrow.png'
import './css/services.css'
import social1 from './images/social1.png'
import social2 from './images/social2.png'
import social3 from './images/social3.png'
import social4 from './images/social4.png'


export default function ContactArea() {
    const [tabbs , settabbs]=useState(1);

    function tabschanger(id){
      settabbs(id)
    }
    
  return (
    <>
      <div className="mainContactArea">
        <div className="row">
          <div className="col-md-12">
          <div className="maintext">
                    <h1>We’d Love to 
                    Speak to you</h1>
                    <div className="underLine"></div>
                </div>
                
          </div>
            
            <div className="col-md-4">
               
                <div className="subtext">
                  <h3>Our Offices</h3>
                </div>

                <div className="tabcontaint">
                  <ul className='tablist'>
                    <li className='innertabcontain' ><button onClick={()=>tabschanger(1)} className={ tabbs===1 ? "tabs1" : "tabs2"} > UAE</button></li>
                    <li className='innertabcontain' ><button onClick={()=>tabschanger(2)} className={ tabbs===2 ? "tabs1" : "tabs2"}> IND</button></li>
                  </ul>
                </div>

                <div className={ tabbs===1 ? "showtabs" : "hidetabs"}>
                  <h1>RAJ Digital Marketing</h1>
                  <p>
                  رأس الخيمة

<br/>Ras Al Khaimah
                <br/>
                  United Arab Emirates</p>
                  
                  
                  <h1>Contact Details</h1>
                  <p>Phn: +971 50 854 5971</p>
                
                  <p>Email: mufaddal@rajdigi.com</p>
                </div>
                <div className={ tabbs===2 ? "showtabs" : "hidetabs"}>
                  <h1>RAJ Digital Marketing</h1>
                  <p>
                    4th Floor, Office No. 410,  
                 
                  Aurora Tower, West Wing,  <br/>
                  Pin Code: 411048<br/>
                  Camp, Pune, Maharashtra</p>
                  <h1>Contact Details</h1>
                  <p>Phn: +91 86198 69612</p>
                  <p>Email: zoher@rajdigi.com</p>
                </div>
                <div className="follow-us-section">
                  <p>Follow Us :</p>
                  <div className="follow-us-section-icon">
                    <ul className='social-icon1' >
                  <i><a href="https://www.linkedin.com/company/raj-digital-marketing-fz-llc/posts/?feedView=all"><img src={social1} alt="" /></a></i>   
                  {/* <i><img src={social2} alt="" /></i>    */}
                  <i><a href="https://www.facebook.com/rajdigitalmarketingagency/"><img src={social3} alt="" /></a></i>   
                  <i><a href="https://www.instagram.com/rajdigitalmarketing/"><img src={social4} alt="" /></a></i> 
                  </ul> 
                 </div>
                </div>
                </div>
            <div className="col-md-8 main-sub-2">
                <div className="contactAreaImg">
                <img src={arrow} alt="" />
                </div>

                <div className="contact-form-container">
    <form action="https://formsubmit.co/zoher@rajdigi.com" method="POST">
      <div className="form-row">
        <div className="form-group">
          <label for="first-name">First Name</label>
          <input type="text" id="first-name" name="first-name" required />
        </div>
        <div className="form-group">
          <label for="last-name">Last Name</label>
          <input type="text" id="last-name" name="last-name" required />
        </div>
        <div className="form-group">
          <label for="email">Email</label>
          <input type="email" id="email" name="email" required />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label for="service-name">Services Name</label>
          <input type="text" id="service-name" name="service-name" required />
        </div>
        <div className="form-group">
          <label for="mobile-number">Mobile Number</label>
          <input type="tel" id="mobile-number" name="mobile-number" required />
        </div>
      </div>
      
      <div className="form-row subimi-button-section">
        <button type="submit">Submit</button>
      </div>
    </form>
  </div>
                

            </div>
            
            </div>
        </div>
      
    </>
  )
}


